import React, { useRef } from 'react';
import { ArrowLeft } from 'lucide-react';
import Button from './Button';

interface Section {
  id: string;
  title: string;
}

interface FormProps {
  sections: Section[];
  onSave: () => void;
  onCancel?: () => void;
  children: React.ReactNode;
  isSubmitting?: boolean;
}

const Form: React.FC<FormProps> = ({
  sections,
  onSave,
  onCancel,
  children,
  isSubmitting = false,
}) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);

    if (element) {
      // Get the main scrollable container from AdminLayout
      const mainContainer = document.querySelector('[data-main-container]');
      if (mainContainer) {
        const headerOffset = 200; // Increased to account for both nav bars
        const elementTop = element.offsetTop;

        mainContainer.scrollTo({
          top: elementTop - headerOffset,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div className="flex flex-col">
      {/* Top Navigation Bar */}
      <div className="sticky top-0 bg-panel border-b border-line z-50">
        <div className="flex justify-between items-center px-4 py-2">
          {/* Section Navigation */}
          <div className="flex space-x-1">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className="px-4 py-2.5 font-['Archivo'] text-[12px] text-muted hover:text-text cursor-pointer hover:bg-[rgba(255,255,255,0.04)] transition-colors focus:outline-none border-b-2 border-transparent hover:border-accent"
              >
                {section.title}
              </button>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-2">
            {onCancel && (
              <Button variant="secondary" onClick={onCancel} icon={ArrowLeft}>
                Back
              </Button>
            )}
            <Button
              onClick={onSave}
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Save
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full">
        <form className="w-full">
          <div className="space-y-5 pt-5">
            {children}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form;
